var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-content',[(!_vm.$route.meta.hideNavigation)?_c('Navbar',{attrs:{"titleNavbar":_vm.titleNavbar,"operatoreNavbar":_vm.operatoreNavbar}}):_vm._e(),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }